import { useQuery } from "@tanstack/react-query";
import { CalculatorKeys } from "web_myplann/Api/Calculators/CalculatorKeys";
import {
	getCalculatorRefinancingRatesV2,
	type MortgageRateResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

export const useRefinancingRatesQuery = () =>
	useQuery({
		queryKey: CalculatorKeys.refinancingRates(),
		queryFn: processResponse(() => getCalculatorRefinancingRatesV2(), {
			skipToastFor: true,
		}),
		select: (response: { data: MortgageRateResponseDTO[] }) => response.data,
	});
